export const DATA_GRID_SEARCH_PARAMS_ID = 'dataGrids';
export const PAGE_SEARCH_PARAMS_ID = 'page';
export const DEFAULT_ROW_INDEX = 1;
export const GRID_ENTRY_SEPARATOR = '|';
/** Separator between gridCode and page number inside the `page` query param value. */
export const PAGE_ENTRY_SEPARATOR = ':';
/** Separator between multiple grid page entries inside the `page` query param value. */
export const PAGE_GRID_SEPARATOR = ',';
export type DataGridSearchParams = {
  gridCode: string;
  queryId: string;
  rowIndex: string;
};